// src/store/index.ts
import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/auth/authSlice';
import jobReducer from './slices/jobs/jobSlice';
import JobAuthReducer from './slices/jobAuth/JobAuthSlice';
import ApplicationReducer from './slices/application/applicationSlice';

const store = configureStore({
  reducer: {
    auth: authReducer,
    jobs: jobReducer,
    jobauth : JobAuthReducer,
    application : ApplicationReducer

  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
